import { component } from 'picoapp'
import { addVariant } from '@/lib/cart.js'
import Swiper from "swiper";
import SwiperCore, { Navigation, Zoom } from "swiper/core";
import {disableBodyScroll, enableBodyScroll} from "body-scroll-lock";

SwiperCore.use([Navigation, Zoom]);

export default component((node, ctx) => {
  const json = JSON.parse(node.querySelector('.js-product-json').innerHTML)
  const form = node.querySelector('form');

  const { selectedOrFirstAvailableVariant, product } = json
  let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0]

  form.addEventListener('submit', e => {
    e.preventDefault();

    const product = JSON.parse($('[data-product-json]').html());

    // NOTE: pass entire variant object below from product JSON object
    const variantId = parseInt($('[data-option-main]').val());

    currentVariant = product.variants.filter(v => v.id === parseInt(variantId))[0];

    addVariant(currentVariant, form.elements.quantity.value)
  });

  //General tabs
  const $tab = $('.js-tab');

  $tab.click(function() {
    const $tabset = $(this).closest('.js-tabset');
    const target = $(this).attr('data-tab-target');
    const $tabTarget = $tabset.find('.js-tab-content[data-tab="' + target + '"]');

    $tabset.find('.js-tab').removeClass('active');
    $tabset.find('.js-tab-content').removeClass('active');

    $tabTarget.addClass('active');
    $(this).addClass('active');

    //Choose first color in tab list
    if ($(this).hasClass('option-tabset__tab--material')) {
      $tabTarget.find('.js-swatch:first-child input').prop('checked', true).trigger('change');
    }

  });

  //Gender tabs
  const $genderTab = $('.js-gender-tab');
  const $genderTabConent = $('.js-gender-tab-content');
  const $prodImgsContainer = $('.js-product-images');
  const $genderImgs = $('.js-gender-img');
  const $genderProperty = $('.js-gender-property');
  const genderActive = 'active';
  const $prodImages = $('.js-product-images');

  $genderTab.click(function() {


    //Get current color
    const currentColor = $('.js-color-select:checked').attr('data-color');

    // Swap gender tabs
    const gender = $(this).attr('data-tab-gender');
    $genderTabConent.attr('data-gender', gender);
    $prodImgsContainer.attr('data-gender', gender);

    //Swap gender images
    if (!$prodImages.hasClass('flickity-enabled')) {
      const $genderMatchedImgs = $('img[data-gender="' + gender + '"]');
      const $genderMatchedProdImgs = $('.product__image[data-gender="' + gender + '"][data-image-color="' + currentColor + '"]');

      $genderImgs.removeClass(genderActive);
      $genderMatchedProdImgs.addClass(genderActive);
      $genderMatchedImgs.addClass(genderActive);
    }

    //Swap gender properties
    $genderProperty.val(gender);

    filterImages(gender);

    //Trigger scroll event to fire lazyloading images
    $(window).trigger("scroll");
  });

  //Product content
  const $prodContent = $('.js-product-info');

  if ($prodContent.length) {
    $prodContent.stick_in_parent({
      offset_top: $('.js-header').height() + 25
    });
  }

  //Content slider
  if (matchMedia('screen and (max-width: 767px)').matches) {
    $('.js-content-slider').flickity({
      cellAlign: 'left',
      lazyLoad: 6,
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      groupCells: true,
      cellSelector: 'img'
    });
  }
  else {
    $('.js-content-slider').flickity({
      cellAlign: 'left',
      lazyLoad: 6,
      pageDots: false,
      groupCells: true,
      contain: true,
      cellSelector: 'img'
    });
  }
});

export function filterImages(gender, lazyload) {
  const $imageSlider = $('.js-product-images');

  function initSlider() {

    let sliderConfig = {
      prevNextButtons: false,
      contain: true,
      groupCells: true,
      pageDots: false,
      cellSelector: '.active'
    }
    if (lazyload == true) {
      $('.js-product-image').each(function() {
        let $img = $(this).find('img');
        $img.attr('data-flickity-lazyload', $img.attr('lazy-src'));
      });
      sliderConfig.lazyLoad = 6;
      lazyload = false;
    }

    $imageSlider.flickity(sliderConfig);

    //Update active image counter
    $('.js-image-length').html($('.product__image.active').length);
    $('.js-image-count').addClass('active');
  }

  //Product Image Slider
  if (matchMedia('screen and (max-width: 767px)').matches) {

    if ($imageSlider.hasClass('flickity-enabled')) {
      $imageSlider.flickity('destroy');


      const currentColor = $('.js-color-select:checked').attr('data-color');
      const $genderMatchedImgs = $('img[data-gender="' + gender + '"]');
      const $genderMatchedProdImgs = $('.product__image[data-gender="' + gender + '"][data-image-color="' + currentColor + '"]');

      $genderMatchedProdImgs.insertAfter($('.js-product-image.active:not(.js-gender-img)').first())

      $('.js-gender-img').removeClass('active');
      $genderMatchedProdImgs.addClass('active');
      $genderMatchedImgs.addClass('active');
    }

    initSlider();
  }
}

export function imagesZoom() {
  const $zoomPopup = $('#images-zoom-popup');

  if (!$zoomPopup.length) {
    return;
  }

  const $zoomPopupContent = $zoomPopup.find('[data-popup-zoom-content]');
  const $zoomPopupCloseBtn = $zoomPopup.find('.js-close-zoom-popup');
  const $navSlideIndex = $zoomPopup.find('[data-slide-index]');
  const $navSlidesCount = $zoomPopup.find('[data-slides-count]');

  const $imagesContainer = $('.js-product-images');
  const $images = $('.js-product-image');
  let $activeImages = $images.filter(".active");
  const popupOpenClass = "popup-zoom--open";

  let imagesSlider = new Swiper('.js-pdp-zoom-slider', {
    slidesPerView: 1,
    navigation: {
      prevEl: '.js-zoom-prev',
      nextEl: '.js-zoom-next'
    },
    zoom: {
      maxRatio: 2
    },
    on: {
      slideChange: function() {
        $navSlideIndex.text(this.activeIndex + 1);
      },
      zoomChange: function(swiper, scale, imageEl, slideEl) {
        if (scale > 1) {
          $zoomPopup.addClass('popup-zoom--hide-text');
        } else {
          $zoomPopup.removeClass('popup-zoom--hide-text');
        }
      }
    }
  });

  $imagesContainer.on("click", '.js-product-image', function() {
    $activeImages = $images.filter(".active");
    const activeIndex = $activeImages.index($(this));

    $zoomPopupContent.empty();
    buildImages($activeImages);
    imagesSlider.update();
    imagesSlider.slideTo(activeIndex, 0);
    $navSlidesCount.text($activeImages.length);
    $zoomPopup.addClass(popupOpenClass);

    disableBodyScroll($zoomPopup[0]);

    let swiperSlides = $zoomPopup[0].getElementsByClassName('swiper-slide');
    swiperSlides.forEach(function (slide) {
      let slideImage = slide.querySelector(".js-popup-zoom-image");

      slideImage.addEventListener("click", function () {
        imagesSlider.zoom.toggle();
      });
    });
  });

  $zoomPopupCloseBtn.click(function() {
    $zoomPopup.removeClass(popupOpenClass);
    enableBodyScroll($zoomPopup[0]);
  })

  function buildImages($images) {
    $images.each(function() {
      const imgUrl = $(this).attr('data-img-large');
      const imgDOM = `<div class="swiper-slide"><div class="swiper-zoom-container"><img class="popup-zoom-image js-popup-zoom-image" src="${imgUrl}" alt="" /></div></div>`;

      $zoomPopupContent.append(imgDOM);
    });
  }
}

export function sizeChartPopup() {
  const sizeChartPopupTrigger = document.querySelector(".js-size-chart-popup-trigger");
  const sizeChartPopup = document.querySelector(".js-size-chart-popup");
  const sizeChartPopupClose = document.querySelector(".js-size-chart-popup-close");

  if (sizeChartPopupTrigger) {
    sizeChartPopupTrigger.addEventListener("click", () => {
      sizeChartPopup.classList.add("size-chart-popup--active");
      disableBodyScroll(sizeChartPopup);

      sizeChartPopup.addEventListener("click", (event) => {
        const target = event.target;

        if (target === sizeChartPopup) {
          sizeChartPopup.classList.remove("size-chart-popup--active");
          enableBodyScroll(sizeChartPopup);
        }
      });

      sizeChartPopupClose.addEventListener("click", (event) => {
        sizeChartPopup.classList.remove("size-chart-popup--active");
        enableBodyScroll(sizeChartPopup);
      });
    });
  }
}


// Back in stock
export function BackToStock() {

  const $bisTrigger = $('.js-bis-trigger');
  const $bisModal = $('.js-bis-modal');
  const $bisForm = $('.js-bis-form');
  const $bisSubmit = $bisForm.find('input[type="submit"]');

  $bisTrigger.click(function () {
    $('body').addClass('no-scroll');
    $bisModal.addClass('active');
  });

  $('.js-close-bis').click(function () {
    $('body').removeClass('no-scroll');
    $bisModal.removeClass('active');

    const $bisSuccess = $('.js-bis-success');

    if ($bisSuccess.length) {
      $bisSuccess.remove();
      $bisSubmit.removeClass('hidden');
    }
  });

  $bisForm.submit(function (e) {
    const activeProduct = parseInt($('[data-product-json]').attr('data-product-id'));
    const activeVariant = parseInt($('[data-option-main]').find(":selected").val());

    const email = $bisForm.find('input[type="email"]').val();

    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      data: {
        a: "KxyUWA",
        email: email,
        variant: activeVariant,
        product: activeProduct,  // Product must be present in Klaviyo catalog to record event.
        platform: "shopify",
        subscribe_for_newsletter: false  // Optional with "g". Defaults to false if omitted.
      },
      success: function (response) {
        $bisForm.find('input[type="submit"]').addClass('hidden');
        $bisForm.append('<p class="js-bis-success success">You\'re in! We\'ll let you know when it\'s back.</p>');
      },
      error: function (response) {
        console.log(response);
      }
    })

    e.preventDefault();
  });
}

$(document).ready(function() {

  const gender = $('.js-gender-tab.active').attr('data-tab-gender');
  filterImages(gender, true);
  imagesZoom();
  sizeChartPopup();
  BackToStock();

  const $imageSlider = $('.js-product-images');
  const $index = $('.js-image-current-index');

  // Load in all product images on lazy load
  $imageSlider.on( 'lazyLoad.flickity', function( event, cellElement ) {
    $('.js-product-image').each(function() {
      let $img = $(this).find('img');
      $img.attr('src', $img.attr('lazy-src'));
    });
  });

  // Set index of slide
  $imageSlider.on('select.flickity', function(event, i) {
    let index = $('.js-product-image.is-selected').index() + 1;
    let newIndex = index;

    if ($index.length) {
      $index.text(newIndex);
    }
  });

  const $contentSlider = $('.js-content-slider');
  const $contentIndex = $('.js-content-image-current-index');

  $contentSlider.on('select.flickity', function(event, i) {
    let index = $('.js-content-slider img.is-selected').index() + 1;
    let newIndex = index;

    if ($contentIndex.length) {
      $contentIndex.text(newIndex);
    }
  });

});
